import type { DeliveryEvent } from './deliveryState'

/**
 * Map delivery analytics (spec §3.8) — the same names on iOS, Android and
 * web, pinned by `deliveryEventParams.test.ts`.
 */
export const MAP_UPDATE_EVENTS = {
  checked: 'map_update_checked',
  downloadStarted: 'map_update_download_started',
  downloadCompleted: 'map_update_download_completed',
  downloadFailed: 'map_update_download_failed',
  bundleRejected: 'map_update_bundle_rejected',
  activated: 'map_update_activated',
  fallbackUsed: 'map_update_fallback_used',
} as const

/** The wire params of a decision's event: only the fields it carries. */
export function deliveryEventParams(event: DeliveryEvent): Record<string, unknown> {
  const params: Record<string, unknown> = {}
  if (event.sequence !== undefined) params.sequence = event.sequence
  if (event.from !== undefined) params.from = event.from
  if (event.to !== undefined) params.to = event.to
  if (event.reason !== undefined) params.reason = event.reason
  return params
}
